import { render, staticRenderFns } from "./RecipeProducts.vue?vue&type=template&id=7fe1a129&scoped=true&"
import script from "./RecipeProducts.vue?vue&type=script&lang=js&"
export * from "./RecipeProducts.vue?vue&type=script&lang=js&"
import style0 from "./RecipeProducts.vue?vue&type=style&index=0&id=7fe1a129&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe1a129",
  null
  
)

export default component.exports